module.exports = __webpack_public_path__ + "assets/img/SG_007.cb67dd4d.jpg";